export type NamingStyle = 'diapositiva' | 'padded-page' | 'custom';

export interface GalleryConfig {
  id: string;
  folder: string;
  total: number;
  naming: NamingStyle;
  /** Used when naming is padded-page, e.g. "ARTICOLI-2025_page-" */
  pagePrefix?: string;
  /** Used when naming is custom, e.g. archivio 2015–2019 */
  customBase?: string;
  /** File extension including dot */
  ext?: string;
  alt?: string;
  pdfUrl?: string;
  backUrl?: string;
  backLabel?: string;
}

export const galleries: Record<string, GalleryConfig> = {
  'articoli-2026': {
    id: 'articoli-2026',
    folder: 'Articoli 2026/',
    total: 24,
    naming: 'diapositiva',
    alt: 'Articolo 2026',
    pdfUrl: 'Articoli 2026.pdf',
    backUrl: 'articoli.html',
    backLabel: 'Torna agli Articoli',
  },
  'articoli-2025': {
    id: 'articoli-2025',
    folder: 'articoli 2025/',
    total: 23,
    naming: 'padded-page',
    pagePrefix: 'ARTICOLI-2025_page-',
    ext: '.jpg',
    alt: 'Articolo 2025',
    pdfUrl: 'ARTICOLI-2025.pdf',
    backUrl: 'articoli.html',
    backLabel: 'Torna agli Articoli',
  },
  'articoli-2024': {
    id: 'articoli-2024',
    folder: 'articoli 2024/',
    total: 44,
    naming: 'padded-page',
    pagePrefix: 'ARTICOLI 2024_page-',
    ext: '.jpg',
    alt: 'Articolo 2024',
    pdfUrl: 'ARTICOLI 2024.pdf',
    backUrl: 'articoli.html',
    backLabel: 'Torna agli Articoli',
  },
  'articoli-2023': {
    id: 'articoli-2023',
    folder: 'Articoli2023/',
    total: 140,
    naming: 'diapositiva',
    alt: 'Articolo 2023',
    pdfUrl: 'Articoli2023.pdf',
    backUrl: 'articoli.html',
    backLabel: 'Torna agli Articoli',
  },
  'articoli-2015-2019': {
    id: 'articoli-2015-2019',
    folder: 'articoli1519/',
    total: 143,
    naming: 'custom',
    customBase: '1777801078577-3bc29f36-2613-4860-9233-0cd052c21de6_',
    ext: '.png',
    alt: 'Articolo archivio',
    pdfUrl: 'articoli1519.pdf',
    backUrl: 'articoli.html',
    backLabel: 'Torna agli Articoli',
  },
  'scatti-2026': {
    id: 'scatti-2026',
    folder: 'scattifotografici 2026/',
    total: 14,
    naming: 'diapositiva',
    alt: 'Scatto 2026',
    pdfUrl: 'SCATTI FOTOGRAFICI 2026.pdf',
    backUrl: 'foto.html',
    backLabel: 'Torna alle Fotografie',
  },
  'scatti-2025': {
    id: 'scatti-2025',
    folder: 'scatti 2025/',
    total: 16,
    naming: 'padded-page',
    pagePrefix: 'SCATTI FOTOGRAFICI 2025_page-',
    ext: '.jpg',
    alt: 'Scatto 2025',
    pdfUrl: 'SCATTI FOTOGRAFICI 2025.pdf',
    backUrl: 'foto.html',
    backLabel: 'Torna alle Fotografie',
  },
  'scatti-2024': {
    id: 'scatti-2024',
    folder: 'SCATTIFOTOGRAFICI 24/',
    total: 49,
    naming: 'diapositiva',
    alt: 'Scatto 2024',
    pdfUrl: 'SCATTIFOTOGRAFICI24.pdf',
    backUrl: 'foto.html',
    backLabel: 'Torna alle Fotografie',
  },
  'scatti-archivio': {
    id: 'scatti-archivio',
    folder: 'SCATTIFOTOGRAFICI/',
    total: 49,
    naming: 'diapositiva',
    alt: 'Scatto archivio',
    pdfUrl: 'SCATTIFOTOGRAFICI.pdf',
    backUrl: 'foto.html',
    backLabel: 'Torna alle Fotografie',
  },
};

export function getImagePath(config: GalleryConfig, index: number): string {
  const ext = config.ext ?? '.JPG';
  switch (config.naming) {
    case 'diapositiva':
      return `${config.folder}Diapositiva${index}${ext === '.jpg' ? '.JPG' : ext}`;
    case 'padded-page':
      return `${config.folder}${config.pagePrefix}${String(index).padStart(4, '0')}${ext}`;
    case 'custom':
      return `${config.folder}${config.customBase}${index}${ext}`;
    default:
      return `${config.folder}${index}${ext}`;
  }
}
